import React, {useMemo, useState} from 'react';
import {FormatAddress} from "../../../helpers/utils";
import graphql from "babel-plugin-relay/macro";
import {useFragment} from "react-relay";
import {BooleanCell, LinkCell, StatusCell} from "../../../components/common/advance-table/CustomCells";
import {useUser} from "../../../hooks/useUser";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import NewPractitionerLocationModal from "./NewPractitionerLocationModal";
import TermLocationsModal from "./TermLocationsModal";

const cols = [
    //here: new cell, for table
    {
        accessor: 'status',
        Header: "Status",
        headerProps: {className: 'pe-1'},
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const {status} = rowData.row.original;
            return <StatusCell value={status} />
        }
    },
    {accessor: 'location.applicableVersion.name',
        Header: 'Name',
        headerProps: { className: 'pe-1' },
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const { location, id } = rowData.row.original;
            return <LinkCell name={location.applicableVersion.name} to={"/practitioner-locations/" + id} hasAvatar />
        }},
    {accessor: 'location.billingGroup.name',
        Header: 'Billing Group',
        headerProps: { className: 'pe-1' },
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const { billingGroup} = rowData.row.original.location;
            return <LinkCell name={billingGroup.tin + " - " + billingGroup.name} to={"/billing-groups/" + billingGroup.id}/>
        }},
    {accessor: 'legalContractLineOfService.lineOfService.name',
        Header: 'Line of Service',
        Cell: rowData => {
            const {legalContractLineOfService} = rowData.row.original;
            return <>{legalContractLineOfService.lineOfService.name}</>
        }},
    {accessor: 'addressLine1',
        Header: 'Address',
        Cell: rowData => {
            const {location} = rowData.row.original;
            return <>{FormatAddress(location.addressLine1, location.addressLine2, "",
                location.city, location.state, location.postalCode)}</>
        }},
    {accessor: 'applicableVersion.showInDirectory', Header: "Show In Directory", Cell:BooleanCell},
   
]
const PractitionerLocations = ({practitionerId, locations, allLocations, availableLineOfServices}) => {
    const data = useFragment(graphql`
    fragment PractitionerLocations_Locations on PractitionerLocation @relay(plural: true) {
        id
        status
        location {
            addressLine1
            addressLine2
            city
            state
            postalCode
            applicableVersion {
                name
            }
            billingGroup {
                id
                name
                tin
            }
        }
        legalContractLineOfService {
            id
            lineOfService {
                id
                name
            }
        }
        applicableVersion {
            showInDirectory
        }
    }`,locations)
    const activeCols = useMemo(() => {
        // Since original cols doesn't have effective dates, but the request says 
        // "show everything else" and "omit effective dates", if it had them I'd remove them.
        // For PractitionerLocations, it seems it doesn't have them in the table currently.
        return cols;
    }, []);
    const {hasPermission} = useUser();
    const [showNewModal, setShowNewModal] = useState(false);
    const [showTermModal, setShowTermModal] = useState(false);
    return (
        <>
            <AdvanceTableWrapper columns={activeCols}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={() => {setShowNewModal(true)}}
                                         title={"Locations"}
                                         table
                                         showNew={hasPermission("PractitionerLocation.Create")} />
                        <button className={"btn btn-falcon-default btn-sm mt-1"} onClick={() => setShowTermModal(true)}>Term</button>
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <TermLocationsModal showModal={showTermModal} onClose={() => {setShowTermModal(false)}} practitionerLocations={locations} />
            <NewPractitionerLocationModal allLocations={allLocations} 
                                          practitionerId={practitionerId}
                                          showModal={showNewModal}
                                          onClose={() => {setShowNewModal(false)}}
                                          availableLinesOfService={availableLineOfServices}
            />
        </>
    )
}
export default PractitionerLocations